import { Component, OnInit } from "@angular/core";
import { DynamicDialogConfig, DynamicDialogRef } from "primeng/dynamicdialog";

@Component({
	selector: "app-view-driver-verify-log-details",
	templateUrl: "./view-driver-verify-log-details.component.html",
	styleUrls: ["./view-driver-verify-log-details.component.css"],
})
export class ViewDriverVerifyLogDetailsComponent implements OnInit {
	constructor(private dialogConfig: DynamicDialogConfig, private ref: DynamicDialogRef) {}

	ngOnInit(): void {
		this.ImageData = this.dialogConfig.data.ImageData;
	}

	ngAfterViewInit() {
		var img = <HTMLImageElement>document.getElementById("MainImage");

		this.ImgHeight = img.height;
		this.ImgWidth = img.width;

		// console.log("Height");
		// console.log(this.ImgHeight);
		// console.log("Width");
		// console.log(this.ImgWidth);
	}

	/////////////////////////////////////////////////////////////////
	// Data
	/////////////////////////////////////////////////////////////////
	ImageData: any;

	rotateDeg: any = 0;
	ImgHeight: any = 0;
	ImgWidth: any = 0;

	/////////////////////////////////////////////////////////////////

	/////////////////////////////////////////////////////////////////
	// Buttons
	/////////////////////////////////////////////////////////////////

	onRotateLeft() {
		this.rotateDeg -= 90;
		this.rotateDeg = this.rotateDeg % 360;

		this.FinishRotate();
	}

	onRotateRight() {
		this.rotateDeg += 90;
		this.rotateDeg = this.rotateDeg % 360;

		this.FinishRotate();
	}

	FinishRotate() {
		var imgDiv = <HTMLElement>document.getElementById("MainImageDiv");

		// console.log("Img");
		// console.log(imgDiv);

		imgDiv.style.transform = "rotate(" + this.rotateDeg + "deg)";

		var abs = Math.abs(this.rotateDeg);

		if (abs == 90 || abs == 270) {
			var newMargin = 15;

			if (this.ImgWidth >= this.ImgHeight) {
				newMargin += (this.ImgWidth - this.ImgHeight) / 2;

				imgDiv.style.margin = newMargin + "px 15px";
			} else {
				newMargin += (this.ImgHeight - this.ImgWidth) / 2;

				imgDiv.style.margin = "15px " + newMargin + "px";
			}
		} else {
			imgDiv.style.margin = "15px";
		}
	}

	onClose() {
		this.ref.close(0);
	}
	/////////////////////////////////////////////////////////////////
}
